import React from 'react';
import { FiClock as Clock } from 'react-icons/fi';
import { AGENCY_PHONE_DISPLAY, AGENCY_PHONE_TEL } from '../constants/contact';

/**
 * Shown while a signed-in account has no `client_id` yet.
 *
 * The alternative is what this app used to do: render every empty state at
 * once and let the client conclude they have no coverage. This says what is
 * actually true -- their account exists and is not yet matched to their
 * record -- and never implies anything about whether they are insured.
 */
const AccountLinkingNotice = () => (
  <div
    role="status"
    className="bg-blue-50 border border-blue-200 rounded-xl p-5 sm:p-6"
  >
    <div className="flex items-start gap-4">
      <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center shrink-0">
        <Clock size={20} className="text-blue-700" />
      </div>
      <div className="flex-1">
        <h2 className="text-lg font-bold text-blue-900 mb-1">
          We&apos;re linking your account
        </h2>
        <p className="text-blue-800">
          You&apos;ll get an email when your policies appear here. Nothing is missing
          from your coverage — we just haven&apos;t matched this login to your record
          yet.
        </p>
        <p className="text-sm text-blue-800 mt-3">
          Need it sooner? Call or text us at{' '}
          <a href={AGENCY_PHONE_TEL} className="font-semibold underline">
            {AGENCY_PHONE_DISPLAY}
          </a>
          .
        </p>
      </div>
    </div>
  </div>
);

export default AccountLinkingNotice;
